var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPeopleAdded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.66675C12.6863 2.66675 10 5.35304 10 8.66675C10 11.9805 12.6863 14.6667 16 14.6667C19.3137 14.6667 22 11.9805 22 8.66675C22 5.35304 19.3137 2.66675 16 2.66675Z",
    fill: "#DB443A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5444 19.5943C21.6296 17.7751 19.03 16.6667 15.9993 16.6667C11.6488 16.6667 8.18665 18.9507 6.36305 22.3426C5.59431 23.7725 5.88097 25.2487 6.73657 26.3131C7.56792 27.3474 8.92677 28.0001 10.393 28.0001H18.9328L17.8661 27.2001C16.5407 26.2059 16.272 24.3255 17.2661 23.0001C18.2603 21.6746 20.1407 21.4059 21.4661 22.4001L21.7384 22.6042L23.5444 19.5943Z",
    fill: "#DB443A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.857 20.1812C28.1411 19.7076 27.9875 19.0933 27.5139 18.8092C27.0403 18.525 26.426 18.6785 26.1419 19.1521L22.3124 25.5346L20.266 24C19.8243 23.6686 19.1975 23.7581 18.866 24.2C18.5347 24.6418 18.6243 25.2686 19.066 25.6L21.9994 27.8C22.2259 27.9698 22.5138 28.0357 22.7916 27.9813C23.0695 27.9269 23.3112 27.7572 23.457 27.5145L27.857 20.1812Z",
    fill: "#DB443A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPeopleAdded);
export default __webpack_public_path__ + "static/media/icon_people_added.e53d612e23759ef7e523b49828502041.svg";
export { ForwardRef as ReactComponent };